import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useTheme } from '@/components/theme-provider';
import { LanguageSwitcher } from '@/components/layout/language-switcher';

export function SiteFooter() {
  const { t } = useTranslation('common');
  const { theme, toggleTheme } = useTheme();

  return (
    <footer className="bg-title border-t-2 border-t-bev-d mt-10">
      <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-3 px-4 py-2.5 sm:px-5">
        <p className="text-titletext font-mono text-xs">{t('footer.copyright')}</p>
        <Link to="/legal" className="text-dim font-mono text-xs hover:text-strong">
          {t('footer.legal')}
        </Link>
        <div className="ml-auto flex items-center gap-1.5">
          <LanguageSwitcher />
          <button
            type="button"
            onClick={toggleTheme}
            className="bevel bg-btn font-display px-2.5 py-1 text-[10px] uppercase text-titletext outline-none transition-[filter] hover:brightness-112 focus-visible:ring-2 focus-visible:ring-ring"
          >
            ◐ {theme === 'dark' ? t('footer.lightTheme') : t('footer.darkTheme')}
          </button>
        </div>
      </div>
    </footer>
  );
}
